import { isEmptyLexicalState } from "src/components/WysiwygEditor/lexical/utils/converters";
import { z } from "zod";

export const generateMessageSchema = (
  hasRecipientsWithEmail: boolean,
  hasRecipientsWithPhone: boolean
) =>
  z.object({
    subject: z.string().superRefine((val, ctx) => {
      if (hasRecipientsWithEmail && !val) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Email subject is required when at least one of your recipients has an email contact method.`,
        });
      }
    }),
    email_body: z.any().superRefine((val, ctx) => {
      if (hasRecipientsWithEmail && isEmptyLexicalState(val)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `Email content is required when one of your recipients has an email contact method.`,
        });
      }
    }),
    email_attachments: z.array(z.instanceof(File)).optional(),
    sms_body: z.any().superRefine((val, ctx) => {
      if (hasRecipientsWithPhone && isEmptyLexicalState(val)) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: `SMS content is required when one of your recipients has an SMS contact method.`,
        });
      }
    }),
  });

export const generateAutomaticMessageSchema = () => {
  return z.object({
    enabled: z.boolean(),
    emailSubject: z.string().min(1, "Email subject is required."),
    emailMarkup: z.string().optional(),
    emailText: z.string().min(1, "Email content is required."),
    emailLexical: z
      .any()
      .optional()
      .superRefine((val, ctx) => {
        if (isEmptyLexicalState(val)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Email content is required.",
          });
        }
      }),
    legacyMarkup: z.string().optional(),
    smsLexical: z
      .any()
      .optional()
      .superRefine((val, ctx) => {
        if (isEmptyLexicalState(val)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: `SMS content is required.`,
          });
        }
      }),
    smsBody: z.string().min(1, "SMS content is required."),
  });
};
